import { Navigate } from 'react-router-dom';

/**
 * Auth-related params that affect Login screen behavior
 */
export const AUTH_PARAMS = [
  'price_id',
  'client_sign_in',
  'login_hint',
  'email_hint',
  'screen_hint',
  'connection',
  'override_connection',
];

/**
 * Builds a login redirect URL that preserves auth-related search parameters
 * and adds the redirect_to parameter pointing to the target URL
 */
export function buildLoginRedirectUrl(targetUrl: string): string {
  const currentParams = new URLSearchParams(window.location.search);
  const loginParams = new URLSearchParams();

  // Preserve existing auth params
  AUTH_PARAMS.forEach(param => {
    const value = currentParams.get(param);
    if (value) {
      loginParams.set(param, value);
    }
  });

  // Remove auth params from targetUrl to avoid duplication
  const targetUrlObj = new URL(targetUrl, window.location.origin);
  AUTH_PARAMS.forEach(param => {
    targetUrlObj.searchParams.delete(param);
  });
  const cleanTargetUrl = targetUrlObj.pathname + targetUrlObj.search;

  // Add redirect_to parameter with cleaned URL
  loginParams.set('redirect_to', cleanTargetUrl);

  return `/?${loginParams.toString()}`;
}

/**
 * Component that redirects unauthenticated users to the login page
 * while preserving auth-related search parameters
 */
export function LoginRedirect() {
  const currentUrl = window.location.pathname + window.location.search;
  return <Navigate to={buildLoginRedirectUrl(currentUrl)} replace />;
}
